import { Reducer } from 'redux';
import { HttpRequestStatus } from '../../../model/enums/httpRequestStatus';
import { DefaultCompanyActionTypes, DefaultCompanyState } from './types';

export const initialState: DefaultCompanyState = {
  status: HttpRequestStatus.NOOP,
  company: undefined,
  error: undefined
};

const reducer: Reducer<DefaultCompanyState> = (state = initialState, action): DefaultCompanyState => {
  switch (action.type) {
    case DefaultCompanyActionTypes.GET_DEFAULT_COMPANY_REQUEST: {
      return { ...state, status: HttpRequestStatus.ON_GOING, company: undefined, error: undefined };
    }
    case DefaultCompanyActionTypes.GET_DEFAULT_COMPANY_SUCCESS: {
      return { ...state, status: HttpRequestStatus.SUCCESS, company: action.payload, error: undefined };
    }
    case DefaultCompanyActionTypes.GET_DEFAULT_COMPANY_ERROR: {
      return { ...state, status: HttpRequestStatus.ERROR, error: action.payload }
    }

    case DefaultCompanyActionTypes.CHANGE_COMPANY_DEFAULT_REQUEST: {
      return { ...state, status: HttpRequestStatus.ON_GOING, company: undefined, error: undefined };
    }
    case DefaultCompanyActionTypes.CHANGE_COMPANY_DEFAULT_SUCCESS: {
      return { ...state, status: HttpRequestStatus.SUCCESS, company: action.payload, error: undefined };
    }
    case DefaultCompanyActionTypes.CHANGE_COMPANY_DEFAULT_ERROR: {
      return { ...state, status: HttpRequestStatus.ERROR, error: action.payload }
    }

    case DefaultCompanyActionTypes.DEFAULT_COMPANY_RESET_STATE: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export { reducer as defaultCompanyReducer };

